import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import Translation from "./translation.service";

var SimDeactivationService = {};

SimDeactivationService.checkNumberType = data => {
// number: String
    let config = {
    method: "get",
    url: `/deactivation/check_number_type?number=${data.number}`,
    };
    return HTTP(config);
};


SimDeactivationService.getPostPaidDeactivationReasons = () => {
    let config = {
        method: "get",
        url: "/deactivation/postpiad_suspend_reasons",
    };
    return HTTP(config);
};

SimDeactivationService.getPrePaidDeactivationReasons = () => {
    let config = {
        method: "get",
        url: "/deactivation/reasons",
        headers: {
            "Virgin-Lang": Translation.getCurrentLanguage()
        }
    };
    return HTTP(config);
};

SimDeactivationService.postPaidRequestOTP = data => {
    // id_number: String (optional)
    // id_type: String (optional) 
    // contact_phone: String (optional)
    // iban: String
    // reason: String
    let config = {
        method: "post",
        url: "/deactivation/create_postpaid_termination_ticket",
        data: data
    };
    return HTTP(config);
};

SimDeactivationService.requestOTPForWeb = data => {
    // number: String,
    // reason_id: String,
    // id_number: String,
    // id_type: String  

    let config = {
        method: "post",
        url: "/deactivation/request_otp_for_web",
        data: data
    };
    return HTTP(config);
};

SimDeactivationService.verifyOTP = data => {
    // number: String
    // otp: string
    // reason_id: string
    let config = {
        method: "post",
        url: "/deactivation/confirm",
        data: data
    };
    return HTTP(config);
};

SimDeactivationService.getClosingBills = number => {
    // number: String
    let config = {
        method: "get",
        url: `/postpaid_bills/closing_bill?number=${number}`,
    };
    return HTTP(config);
};

SimDeactivationService.postPaidLineSuspend = data => {
    // number: String
    // reason: String
    let config = {
        method: "post",
        url: "/deactivation/suspend_postpaid",
        data: data
    };
    return HTTP(config);
};

SimDeactivationService.CreateTerminationTicket = data => {
    // id_number: String
    // id_type: String
    // contact_phone: String
    // iban: String
    // reason: String
    let config = {
        method: "post",
        url: "/deactivation/create_postpaid_termination_ticket",
        data: data
    };
    return HTTP(config);
};

SimDeactivationService.postPaidLineReconnect = data => {
    // number: String
    let config = {
        method: "post",
        url: "/deactivation/reconnect_postpaid",
        data: data
    };
    return HTTP(config);
};
    
SimDeactivationService.billPaymentVerifyTap = (data) => {
    Helpers.debug_payment("SimDeactivationService.billPaymentVerifyTap", data);
    let config = {
        method: "post",
        url: "/postpaid_bills/bill_pay_confirmation_web",
        data: data,
    };
    return HTTP(config);
};

export default SimDeactivationService;
